import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "g-row g-row--align_center g-row--appearance_spaced g-row--space_lg-lg g-row--space_xl-xl" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_3 = { class: "sign-up-role" }
const _hoisted_4 = ["value", "checked", "onChange"]
const _hoisted_5 = { class: "sign-up-role__title" }
const _hoisted_6 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_8 = { class: "ds-inliner ds-inliner--size_lg" }
const _hoisted_9 = { class: "ds-inliner__body" }
const _hoisted_10 = { class: "g-cell g-cols g-cols--10" }
const _hoisted_11 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_12 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_13 = { class: "ds-inliner ds-inliner--size_xl" }
const _hoisted_14 = { class: "ds-inliner__body" }
const _hoisted_15 = { class: "g-cell g-cols g-cols--10 ellipsis-content ellipsis-content--1" }
const _hoisted_16 = { class: "global-error" }
const _hoisted_17 = { class: "global-error" }
const _hoisted_18 = { class: "global-error" }
const _hoisted_19 = { class: "g-cell g-cols g-cols--12 sk-space_mt sk-space_mt--5 sk-space_mt--8-lg" }
const _hoisted_20 = { class: "g-cell g-cols g-cols--12 g-cols--auto-xl" }
const _hoisted_21 = { class: "g-row g-row--align_center g-row--appearance_spaced" }
const _hoisted_22 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_23 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_24 = { class: "ds-caption ds-caption--size_2xs ds-caption--color_1 ds-caption--appearance_medium ds-caption--appearance_start" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_28 = { class: "global-error" }
const _hoisted_29 = { class: "g-cell g-cols g-cols--12 sk-space_mt sk-space_mt--4" }
const _hoisted_30 = { class: "ds-caption ds-caption--appearance_center ds-caption--size_xs" }
const _hoisted_31 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DPhone = _resolveComponent("DPhone")!
  const _component_DAddressInput = _resolveComponent("DAddressInput")!
  const _component_vee_error = _resolveComponent("vee-error")!
  const _component_d_control_recaptcha = _resolveComponent("d-control-recaptcha")!
  const _component_ControlButton = _resolveComponent("ControlButton")!
  const _component_VeeField = _resolveComponent("VeeField")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, {
    onSubmit: $setup.request,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, validate, values, setErrors, setFieldError, isSubmitting }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.USER_ROLE_MAP, (role, i) => {
              return _createElementVNode("label", {
                class: _normalizeClass(["sign-up-role__item", { 'is-active': $setup.currentUserType.id === role.id}]),
                key: i
              }, [
                _createElementVNode("input", {
                  class: "sign-up-role__input",
                  type: "radio",
                  name: "user_role",
                  value: role.id,
                  checked: $setup.currentUserType.id === role.id,
                  onChange: ($event: any) => ($setup.onChangeRole(role))
                }, null, 40, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(role.title), 1)
              ], 2)
            }), 64))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.FIELDS, ({ name, label, component, mask, size, ...rest }) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["g-cell g-cols g-cols--12", `g-cols--${size || 6}-lg`])
          }, [
            ('phone' === name)
              ? (_openBlock(), _createBlock(_component_DPhone, _mergeProps({
                  key: 0,
                  name: name,
                  errors: errors,
                  "input-label": label,
                  size: ['md', 'md-xl'],
                  "static-label": true,
                  modelValue: $setup.form[name],
                  "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                  ref_for: true
                }, rest, {
                  rules: `required|realPhone:${$setup.form.phone}`
                }), null, 16, ["name", "errors", "input-label", "modelValue", "onUpdate:modelValue", "rules"]))
              : ('location' === name)
                ? (_openBlock(), _createBlock(_component_DAddressInput, _mergeProps({
                    key: 1,
                    name: name,
                    errors: errors,
                    "input-label": label,
                    size: ['md', 'md-xl'],
                    "static-label": true,
                    modelValue: $setup.form[name],
                    "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                    ref_for: true
                  }, rest, {
                    country: $setup.form.country
                  }), null, 16, ["name", "errors", "input-label", "modelValue", "onUpdate:modelValue", "country"]))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(component || 'd-input'), _mergeProps({
                    key: 2,
                    name: name,
                    errors: errors,
                    "input-label": label,
                    size: ['md', 'md-xl'],
                    "static-label": true,
                    modelValue: $setup.form[name],
                    "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                    ref_for: true
                  }, rest, {
                    rules: $setup.isNotRequiredRestField.includes(name) ? '' : rest.rules,
                    key: JSON.stringify($setup.isNotRequiredRestField.includes(name) ? '' : rest.rules)
                  }), {
                    option: _withCtx(({ option }) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                              }, null, 2)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                        ])
                      ])
                    ]),
                    singleLabel: _withCtx(({ option }) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                              }, null, 2)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1040, ["name", "errors", "input-label", "modelValue", "onUpdate:modelValue", "rules"]))
          ], 2))
        }), 256)),
        _createVNode(_component_vee_error, {
          class: "g-cell g-cols g-cols--12",
          name: "nonFieldErrors",
          as: "div"
        }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(message), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vee_error, {
          class: "g-cell g-cols g-cols--12",
          name: "recaptcha",
          as: "div"
        }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_17, _toDisplayString(message), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vee_error, {
          class: "g-cell g-cols g-cols--12",
          name: "location:nonFieldErrors",
          as: "div"
        }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_18, _toDisplayString(message), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_d_control_recaptcha, {
          class: "control-descriptor--clear",
          modelValue: $setup.form.captcha,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.captcha) = $event)),
          ref: "captchaConfirmedRef",
          onVerify: ($event: any) => ($setup.saveConfirmedCaptcha($event, setFieldError))
        }, null, 8, ["modelValue", "onVerify"]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode($setup["TokenConfirmationCheck"], {
            token: $setup.form.email,
            action: $event => $setup.redirect($event, $setup.formRef)
          }, {
            default: _withCtx(({ is_confirmed, sendCode, openModal }) => [
              _createVNode(_component_d_control_recaptcha, {
                class: "control-descriptor--clear",
                modelValue: $setup.form.captcha,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.captcha) = $event)),
                ref: "captchaRef",
                onVerify: ($event: any) => ($setup.saveCaptcha($event, $setup.formRef, openModal))
              }, null, 8, ["modelValue", "onVerify"]),
              _createVNode(_component_ControlButton, {
                styling: 'primary',
                size: ['md', 'lg-xl'],
                view: "full",
                disabled: isSubmitting || $setup.isLoad,
                type: "submit",
                onClick: _withModifiers(($event: any) => ($setup.validateForm(validate, $setup.getCaptcha, $setup.formRef)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.$t('Sign up')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 2
          }, 1032, ["token", "action"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_VeeField, {
                name: "agreeTerms",
                rules: "required",
                id: "agreeTerms",
                type: "checkbox",
                "checked-value": true,
                "unchecked-value": false,
                value: true,
                modelValue: $setup.form.agreeTerms,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.agreeTerms) = $event)),
                as: "control-checkbox"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _createTextVNode(_toDisplayString($setup.$t('By checking this box, I consent to the processing of my personal data in accordance with the')) + " ", 1),
                _createElementVNode("a", {
                  class: "sk-link sk-link--appearance_underline sk-link--size_xs sk-link--inline",
                  href: $setup.userAgreement,
                  target: "_blank"
                }, _toDisplayString($setup.$t('User agreement')), 9, _hoisted_25),
                _createTextVNode(" " + _toDisplayString($setup.$t('and')) + " ", 1),
                _createElementVNode("a", {
                  class: "sk-link sk-link--appearance_underline sk-link--size_xs sk-link--inline",
                  href: $setup.privacyPolicy,
                  target: "_blank"
                }, _toDisplayString($setup.$t('Privacy Policy')), 9, _hoisted_26)
              ])
            ]),
            _createVNode(_component_VeeError, { name: "agreeTerms" }, {
              default: _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(message), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, [
            _createTextVNode(_toDisplayString($setup.$t("Already have an account?") + " "), 1),
            _createElementVNode("a", {
              class: "ds-link ds-link--styling_primary",
              href: $props.loginUrl
            }, _toDisplayString($setup.$t('Login')), 9, _hoisted_31)
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}